import Vue from "vue";
import VueFakeScroll from "vue-fake-scroll"
import App from "./App.vue";
import store from "./store";
import router from "./router";
import * as Tabs from "vue-slim-tabs";
import { VueHammer } from 'vue2-hammer';
import Vue2TouchEvents from 'vue2-touch-events';
import VuePlyr from 'vue-plyr';
import VueTimers from 'vue-timers'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faCaretSquareLeft } from '@fortawesome/free-solid-svg-icons'
import { faCaretSquareRight } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'

import { faHeadphones } from '@fortawesome/free-solid-svg-icons'

import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import IdleVue from 'idle-vue'



library.add(faChevronRight)
library.add(faChevronLeft)
library.add(faChevronDown)
library.add(faFacebookF)
library.add(faTwitter)
library.add(faWhatsapp)
library.add(faHeadphones)

library.add(faCaretSquareLeft)
library.add(faCaretSquareRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-fake-scroll', VueFakeScroll)


Vue.config.productionTip = false;

VueHammer.config.swipe = {
  threshold: 1,
  velocity: 0.1
};

Vue.use(Tabs);
Vue.use(VueHammer);
Vue.use(Vue2TouchEvents);
Vue.use(VuePlyr);
Vue.use(BootstrapVue);
Vue.use(VueTimers);

const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 7000
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
